import dayjs from 'dayjs';

const isoDateFormat = () =>
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?(?:[-+]\d{2}:?\d{2}|Z)?$/;

const isDate = () => /^\d{4}-\d{2}-\d{2}$/;

const isIsoDateString = (value: any): boolean => {
    return value && typeof value === 'string' && isoDateFormat().test(value);
};

const isDateString = (value: any): boolean => {
    return value && typeof value === 'string' && isDate().test(value);
};

export const handleDates = (body: any) => {
    if (body === null || body === undefined || typeof body !== 'object')
        return body;

    for (const key of Object.keys(body)) {
        const value = body[key];
        if (isIsoDateString(value) || isDateString(value))
            body[key] = dayjs.utc(value);
        else if (typeof value === 'object') handleDates(value);
    }
};
